import { createStore } from 'vuex';
import App from './app.module';
import User from './user.module';
import Auth from './auth.module';
import Config from './config.module';
import SeatAllocation from './seatAllocation.module';
import Routing from './routing.module';
import SeatDesigner from './seatDesigner.module';

import Backdrop from '@fifa-bsm/bo-frontend-shared/components/AppBackdrop/backdrop.module';

export const modules = {
    App,
    User,
    Auth,
    Config,
    SeatAllocation,
    SeatDesigner,
    Backdrop,
    Routing,
};

export const createAppStore = () => {
    return createStore({
        modules,
        strict: import.meta.env.NODE_ENV !== 'production',
    });
};

export const store = createAppStore();
